import styled from 'styled-components';
import Icon from '@minecraft.icon';

export const Wrapper = styled.div`
  align-items: center;
  border-radius: 1.5625rem;
  background-color: ${(props): string => props.theme.filters.pill.backgroundColor};
  display: inline-flex;
  height: 1.375rem;
  padding-left: 0.75rem;
`;

export const PillText = styled.span`
  color: ${(props): string => props.theme.filters.pill.color};
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const ClearButton = styled.div`
  display: flex;
  padding: 0.375rem 0.75rem;
`;

export const ClearIcon = styled(Icon)`
  flex-shrink: 0;
  margin: auto;
  height: 0.625rem;
  width: 0.625rem;
`;
